'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef, useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
interface PullQuoteProps {
  quote: string;
  attribution?: string;
  className?: string;
}
const PullQuote = t0 => {
  const $ = _c(25);
  const {
    quote,
    attribution,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const containerRef = useRef(null);
  const lineRef = useRef(null);
  const quoteMarkRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const wordsRef = useRef(t2);
  const attributionRef = useRef(null);
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      gsap.registerPlugin(ScrollTrigger);
      const ctx = gsap.context(() => {
        const trigger = {
          trigger: containerRef.current,
          start: "top 88%",
          toggleActions: "play none none none"
        };
        gsap.fromTo(lineRef.current, {
          scaleY: 0,
          transformOrigin: "top center"
        }, {
          scaleY: 1,
          duration: 0.9,
          ease: "power3.out",
          scrollTrigger: trigger
        });
        gsap.fromTo(quoteMarkRef.current, {
          opacity: 0,
          scale: 0.4,
          y: -8
        }, {
          opacity: 1,
          scale: 1,
          y: 0,
          duration: 0.7,
          delay: 0.2,
          ease: "back.out(1.7)",
          scrollTrigger: trigger
        });
        const validWords = wordsRef.current.filter(Boolean);
        if (validWords.length > 0) {
          gsap.fromTo(validWords, {
            opacity: 0,
            y: 14,
            filter: "blur(6px)"
          }, {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 0.65,
            stagger: 0.035,
            delay: 0.35,
            ease: "power3.out",
            scrollTrigger: trigger
          });
        }
        if (attributionRef.current) {
          gsap.fromTo(attributionRef.current, {
            opacity: 0,
            y: 8
          }, {
            opacity: 1,
            y: 0,
            duration: 0.6,
            delay: 0.9,
            ease: "power2.out",
            scrollTrigger: trigger
          });
        }
      }, containerRef);
      return () => ctx.revert();
    };
    t4 = [];
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useEffect(t3, t4);
  let t10;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== className || $[4] !== quote) {
    const words = quote.split(" ");
    t7 = containerRef;
    t8 = `relative pl-8 md:pl-12 ${className}`;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <div ref={lineRef} data-accent-line={true} className="absolute left-0 top-0 h-full w-px bg-gradient-to-b from-primary via-accent to-transparent" aria-hidden="true" />;
      t10 = <span ref={quoteMarkRef} className="-ml-1 block font-serif text-7xl leading-none text-primary/25 -mb-2" aria-hidden="true">“</span>;
      $[11] = t10;
      $[12] = t9;
    } else {
      t10 = $[11];
      t9 = $[12];
    }
    t5 = "text-2xl font-serif italic leading-relaxed text-zinc-100 md:text-3xl";
    t6 = words.map((word, i) => <span key={i} ref={el => {
      wordsRef.current[i] = el;
    }} className="mr-[0.28em] inline-block will-change-transform">{word}</span>);
    $[3] = className;
    $[4] = quote;
    $[5] = t10;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t10 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[13] !== t5 || $[14] !== t6) {
    t11 = <blockquote className={t5}>{t6}</blockquote>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== attribution) {
    t12 = attribution && <p ref={attributionRef} data-attribution={true} className="mt-5 font-mono text-[11px] uppercase tracking-[0.35em] text-zinc-500">— {attribution}</p>;
    $[16] = attribution;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t12 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t13 = <div ref={t7} className={t8}>{t9}{t10}{t11}{t12}</div>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
};
export { PullQuote };